module.exports = __webpack_public_path__ + "img/product-ketang-zzct-01.a04b830b.png";